import { useTheme } from "@mui/joy"
import { useMediaQuery } from "@mui/material"
import React, { useEffect, useRef } from "react"
import { useAppContext } from "../../app/Context"

export function UserVideo() {
  const videoRef = useRef(null)
  const appContext = useAppContext()
  const videoStream = appContext.stream
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  useEffect(() => {
    if (videoStream) {
      try {
        videoRef.current.srcObject = videoStream
      } catch (error) {
        console.error(error)
      }
    }
  }, [videoStream])

  const mobileDimension = "clamp(100px, 20vw, 140px)"
  const videoWidth = isMobile ? mobileDimension : "200px"
  const videoHeight = isMobile ? mobileDimension : "144px"

  return (
    <div
      className="user-video-container"
      style={{
        width: videoWidth,
        height: videoHeight,
        borderRadius: "var(--spacing-tokens-size-in-px-spacing-spacing-xl)",
        overflow: "hidden",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.4)",
      }}
    >
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        className="w-full h-full object-cover object-top scale-x-[-1]"
      />
    </div>
  )
}
